import React from 'react'
import { Skeleton, ResponsiveTableRow } from '@fs/zion-ui'

const EntrySkeleton = (): JSX.Element => {
  return (
    <ResponsiveTableRow
      data-testid="entry-skeleton"
      column1={<Skeleton.Paragraph maxWidth={150} size="sm" />}
      column2={
        <>
          <div>
            <Skeleton.Paragraph maxWidth={100} size="sm" />
          </div>
          <div>
            <Skeleton.Paragraph maxWidth={175} size="sm" />
          </div>
          <Skeleton.Paragraph maxWidth={150} size="sm" />
        </>
      }
      column3={
        <>
          <Skeleton.Paragraph maxWidth={160} size="xs" />
          <Skeleton.Chip />
        </>
      }
      column4={<Skeleton.Button data-testid="entry-skeleton-button" />}
    />
  )
}

type EntrySkeletonsProps = {
  count: number
}

const EntrySkeletons = ({ count }: EntrySkeletonsProps): JSX.Element => {
  return (
    <>
      {Array.from({ length: count }, (_, index) => (
        <EntrySkeleton key={`${index}_skel`} />
      ))}
    </>
  )
}

export default EntrySkeletons
